
export function parseDollarAmount(str: string | undefined): string | undefined {
  if (!str) { return }

  return str.trim().replace(/^\$\s*/, '').replace(/,/g, '');
}
